//HeaderBasic.vue



<template>

	<div id="container">

		<div id="container-logo">
			<!-- <img id="bg-logo" :src="'imgs/bollingergrohmann-removebg.svg'" @click="goHome"/> -->
			<!-- <img id="buw-logo" :src="'imgs/buw.png'" /> -->
		</div>

		<div id="container-nav">

			<button class="btn-nav" id="btn-go-home">
				<router-link class="router-link-text-home" to="/">Go Home</router-link>
			</button>

			<button class="btn-nav" id="btn-logout" @click="logOutClicked">
					<!-- <router-link class="router-link-text-home" to="/">Log out</router-link> -->
					Log out
			</button>

			<p id="beta">
				beta
			</p>

		</div>

	</div>
	
</template>


<script>

export default {
	components: {
		
	},
	data() {
		return {
			msg: "",
			loggedInStatus: '',
			adminStatus: ''
		}
	},
	methods: {
		goHome() {
			this.$router.replace({ name: "Home" });
		},
		logOutClicked() {
			var loggedInStatus = JSON.stringify('loggedOut');
			localStorage.setItem('loggedInStatus', loggedInStatus); 

			var adminStatus = JSON.stringify('notAdmin');
			localStorage.setItem('adminStatus', adminStatus); 

			console.log('loggedInStatus after log out', localStorage.loggedInStatus);
			console.log('adminStatus after log out', localStorage.adminStatus);

			this.$router.replace({ name: "Home" });
		}
	},
}

</script>





<style scoped>

@font-face{
	src: url("/fonts/Roboto-Black.ttf");
	font-family: Roboto;
}

#container {
	display: flex;
	justify-content: space-between; 
	align-items: center;
	height: 60px;
	width: 100vw;
}

#container-logo {
	display: flex;
	justify-content: space-between; 
	align-items: center;
	/* border: 1px solid black; */
	/* height: 60px; */
	/* width: 100vw;  */
}

#container-nav {
	display: flex;
	/* border: 1px solid black; */
}

#bg-logo {
	/* border: solid 1px black; */
	height: 100px;
	margin-left: 10px;
	opacity: .8;
	cursor: pointer; 
}

#buw-logo {
	height: 25px;
	margin-left: 10px;
	display: block;
	opacity: 1;
}

.router-link-text-home {
	text-decoration: none;
	color:black;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-size: .9rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.8);
}

.btn-nav{
	/* margin-right: 20px; */
	position: relative;
	background: transparent;
	border: none;
	margin: 0 20px;
	text-decoration: none;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-size: .9rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.8);
	cursor: pointer;
}

.btn-nav:after {
	content: "";
	position: absolute;
	background-color: black;
	height: 1px;
	width: 0;
	left: 0;
	bottom: 10px;
	transition: 0.3s;
	transform: scale(0);
	transform-origin: center;
}

.btn-nav:hover:after {
	width: 100%;
	transform: scale(1);
}

#btn-logout {
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	margin-right: 60px;
	font-size: 14px;
}

#beta {
	margin-right: 80px;
	font-family: 'Lato', sans-serif;
	color: rgba(0, 0, 0, 0.6);
	font-weight: 600;
}

</style>